<template>
  <div>
    <crumb-tit>
      <span
        slot="breadTit"
        v-text="title"
      />
      <span
        slot="secondTit"
        v-text="title"
      />
    </crumb-tit>
    <div
      v-if="!loadContent"
      class="logo_main"
      :class="{'en-form': isEnglish}"
    >
      <div
        v-if="!isVip && !loadContent"
        class="logo_alert"
      >
        <a-alert
          :message="alertTip"
          banner
        />
        <router-link :to="{name: 'ServiceIndex'}">
          {{ $t('message["902"]') }}
        </router-link>
      </div>
      <div class="sms_item">
        <p class="item_title">
          {{ $t('message["1318"]') }}logo：
        </p>
        <div class="item_main">
          <div class="logo_pic">
            <div
              class="upload_img"
              :style="{backgroundImage: `url(${logoInfo.logo})`, backgroundColor: '#f2f2f2'}"
            />
          </div>
          <div class="upload_btn">
            <!--加上"{'X-Requested-With': null}"后可解决跨域问题 -->
            <a-upload
              :disabled="!isVip"
              :show-upload-list="false"
              :before-upload="beforeUpload"
              :headers="{'X-Requested-With': null}"
              @change="changeUpload"
            >
              <a-button class="upload">
                {{ $t('message["993"]') }}
              </a-button>
            </a-upload>
            <span class="upload_warning">{{ $t('message["1592"]') }}5M。</span>
          </div>
        </div>
      </div>
    </div>
    <a-spin
      v-if="uploading"
      class="spin-style"
    />
  </div>
</template>

<script type="text/ecmascript-6">
import CrumbTit from '@/components/pc/config/CrumbTit'
import { mapActions, mapMutations, mapState } from 'vuex'
import { upyunUpload } from './config'
import axios from 'axios'
import { getLang } from '@/lib/storage'
export default {
  components: {
    CrumbTit
  },
  data () {
    return {
      logoInfo: {},
      actionUrl: upyunUpload,
      uploadInfo: {},
      setLogoInfo: {},
      tempUrl: '',
      file: ''
    }
  },
  computed: {
    ...mapState(['baseinfo']),
    ...mapState('config/logo', ['loadContent', 'uploading']),
    isVip () {
      return this.logoInfo.vip === 1
    },
    title () {
      const { title } = this.$route.meta
      return title
    },
    alertTip () {
      return this.$t('message["1664"]')
    },
    isEnglish () {
      return this.getLang() === 'en'
    }
  },
  watch: {
    baseinfo (newVal) {
      document.title = this.title + ' - ' + newVal.projectname + '-' + newVal.comname
    }
  },
  created () {
    this.getLogoInfo()
  },
  methods: {
    ...mapActions('config/logo', ['getLogoInitInfo', 'uploadNewLogo', 'setProjectLogo']),
    ...mapMutations(['setBaseInfoField']),
    getLang,
    beforeUpload (result) {
      this.file = result
      const { type, size, name } = result
      const isJPGPNG = (type === 'image/jpeg' || (type === 'image/png'))
      const isLt5M = (size / 1024 / 1024) < 5
      if (!isJPGPNG) {
        this.$message.error(this.$t('message["1320"]'))
        return false
      }
      if (!isLt5M) {
        this.$message.error(this.$t('message["1319"]') + ' 5MB!')
        return false
      }
      const filename = [ name ]
      if (isJPGPNG && isLt5M) {
        const _this = this
        return new Promise(async (resolve, reject) => {
          const chain = await _this.uploadNewLogo()
          chain.params({ filename })
            .onSuccess(res => {
              const { _upt, policy, signature, domain } = res[0]
              _this.uploadInfo = Object.assign({}, { policy }, { signature }, { file: _this.file }, { domain }, { _upt })
              _this.handleUpload(_this.uploadInfo)
              resolve()
            })
            .fetch()
        })
      }
    },
    handleUpload (data) {
      const _this = this
      const { policy, signature, file, domain, _upt } = data
      const formData = new FormData()
      formData.append('policy', policy)
      formData.append('signature', signature)
      formData.append('file', file)
      axios.post(_this.actionUrl, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(result => {
        const { url } = result.data
        const { type, size, name } = _this.file
        let setLogoData = {
          file_name: name,
          file_size: size,
          file_type: type,
          file_url: url
        }
        _this.setPtojectLogoInfo(setLogoData)
        _this.logoInfo.logo = domain + _upt
      }).catch(err => {
        console.log(err)
      })
    },
    changeUpload (info) {
      if (info.file.status === 'done' && JSON.stringify(this.uploadInfo) !== '{}') {
        this.setPtojectLogoInfo(this.setLogoInfo)
        this.logoInfo.logo = this.tempUrl
      }
    },
    async getLogoInfo () {
      const chain = await this.getLogoInitInfo()
      chain.onSuccess(res => {
        this.logoInfo = res
      })
        .fetch()
    },
    async setPtojectLogoInfo (params) {
      const chain = await this.setProjectLogo(params)
      chain.onSuccess((res, all) => {
        // 设置头部组件logo
        this.setBaseInfoField({ field: 'logo', num: this.tempUrl })
      })
        .fetch()
    }
  }
}
</script>

<style scoped lang="scss">
.logo_main {
  margin-top: 16px;
  .logo_alert {
    position: relative;
    margin: 16px 0;
    a {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 540px
    }
  }
  .sms_item {
  position: relative;
  min-height: 56px;
  margin: 32px 0;
  .item_title {
    width: 70px;
    position: absolute;
    top: 0;
    font-size:14px;
    color:#666;
    line-height:24px;
    text-align: right;
  }
  .item_main {
    display: inline-block;
    position: absolute;
    top: 0;
    left: 85px;
    .logo_pic {
      position: relative;
      width:80px;
      height:80px;
      background:#fff;
      border-radius:4px;
      border:1px dashed #D6D6D6;
      display: inline-block;
      .upload_img {
        width: 64px;
        height: 64px;
        margin: 7px auto 0;
        border-radius: 4px;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
      }
    }
    .upload_btn {
      position: absolute;
      top: 0;
      min-width: 400px;
      margin: 0 14px 0 99px;
      .upload {
        vertical-align: middle
      }
      .upload_warning {
        color: #B3B3B3;
        line-height: 32px;
        vertical-align: middle
      }
    }
  }
}
}
.spin-style {
  position: absolute;
  top: 50%;
  left: 50%;
}
.en-form {
  .sms_item {
    .item_title {
      width: 100px;
    }
    .item_main {
      left: 115px;
      .upload_btn {
        min-width: 600px;
      }
    }
  }
}
</style>
